import * as React from 'react'
import { Input as AntInput } from 'antd'
import type { InputProps as AntInputProps } from 'antd'

export type InputProps = AntInputProps & {
  ref?: React.Ref<unknown>
}

const Input = React.forwardRef<any, AntInputProps>(
  (props, ref) => (
    <AntInput
      ref={ref}
      className={`!bg-white hover:!bg-white focus:!bg-white ${props.className || ''}`}
      style={{ borderRadius: '9999px', ...props.style }}
      {...props}
    />
  ),
) as any;

Input.displayName = 'Input'
Input.TextArea = AntInput.TextArea

export { Input }